import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorAutoSavings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M5.837 6.515a8.25 8.25 0 0 1 14.382 4.767.75.75 0 1 0 1.494-.13c-.469-5.365-5.197-9.334-10.561-8.865a9.72 9.72 0 0 0-6.488 3.29l-.106-1.209a.75.75 0 1 0-1.494.13l.26 2.99a.75.75 0 0 0 .813.681l2.989-.26a.75.75 0 0 0-.13-1.495l-1.159.101Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M15.852 10.118v-1.8H8.415v1.8h2.742v1.176c-2.229.1-3.907.535-3.907 1.057 0 .522 1.678.958 3.907 1.057v3.774h1.953v-3.775c2.22-.1 3.89-.535 3.89-1.056 0-.52-1.67-.956-3.89-1.056v-1.177h2.742Zm.308 2.127c0 .343-1.297.631-3.05.711l-.113.005h-.012l-.107.004h-.011l-.24.007h-.005l-.109.002h-.03l-.086.001h-.543l-.084-.001h-.03l-.101-.002h-.011l-.355-.01h-.002l-.116-.006c-1.76-.079-3.067-.368-3.067-.713s1.306-.634 3.067-.713v1.091a18.95 18.95 0 0 0 1.954 0v-1.088c1.754.08 3.051.368 3.051.712Zm-13.191-.21a.75.75 0 0 1 .812.682 8.25 8.25 0 0 0 14.382 4.768l-1.158.1a.75.75 0 1 1-.13-1.494l2.988-.26a.75.75 0 0 1 .812.681l.261 2.99a.75.75 0 1 1-1.494.13l-.106-1.21a9.72 9.72 0 0 1-6.488 3.291c-5.364.468-10.093-3.5-10.56-8.865a.75.75 0 0 1 .681-.812Z"
    />
  </svg>
);
export default SvgTwoColorAutoSavings;
